import { render, staticRenderFns } from "./activityClaimDetail.vue?vue&type=template&id=119d782b&scoped=true"
import script from "./activityClaimDetail.vue?vue&type=script&lang=js"
export * from "./activityClaimDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/components/problemDetails/problemDetail.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./activityClaimDetail.vue?vue&type=style&index=2&id=119d782b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d782b",
  null
  
)

export default component.exports